import { v4 as uuidv4 } from 'uuid';
import { DsSgDatePicker } from '@sgdocs/design-system';

export const DateJsonSchemaWidget = ({
  value,
  onChange,
}: {
  value: string;
  onChange: (newValue: string | undefined) => void;
}): JSX.Element => {
  return (
    <DsSgDatePicker
      id={uuidv4()}
      onChange={onChange}
      initDate={new Date(value)}
      displayFormat={'dd/MM/yyyy'}
      placeholder={''}
    />
  );
};
